import React, { useEffect, useState } from "react";

import {
  getSQLReportDetail,
  getSQLReportView,
} from "../../services/reports_services";
import Table from "../../components/Table";
import withTable, { TableContext } from "../../hoc/withTable";
import axios from "axios";
import { toast } from "react-toastify";
import { API_URL } from "../../../lib/const";
import ActionDropdown from "../../components/ActionDropdown";

const SQLReportViewPage = ({ match }) => {
  const [columns, setColumns] = useState(null);
  const [reportData, setReportData] = useState(null);
  const { id } = match.params;

  const getColumns = async () => {
    const report_data = await getSQLReportDetail(id);
    setReportData(report_data);
    let arrayHeader = [];
    if (report_data.headers) {
      report_data.headers.map((header) => {
        arrayHeader.push({
          Header: header.toUpperCase(),
          accessor: header.toLowerCase(),
          minWidth: 400,
        });
      });
    }
    return setColumns(arrayHeader);
  };
  useEffect(
    () => {
      if (!columns) {
        getColumns();
      }
    },
    [columns]
  );

  const downloadExcel = () => {
    return axios
      .get(`${API_URL}/reports/sql_reports/excel/?report_id=${id}`, {
        responseType: "blob",
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Relatório - ${reportData.name}.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch(() => {
        toast.error(
          "Ocorreu um erro ao fazer o download do arquivo. Por favor, tente novamente."
        );
      });
  };
  const handleAction = (action) => {
    switch (action) {
      case "EXPORT_EXCEL":
        downloadExcel();
    }
  };
  if (!columns) {
    return <>Loading...</>;
  }
  return (
    <div className="p-3 d-flex flex-column justify-center align-center">
      <div className="w-100 d-flex align-center justify-content-between">
        <h4>Relatório: {reportData.name}</h4>
        <ActionDropdown
          onClick={handleAction}
          actions={[{ label: "Exportar para Excel", value: "EXPORT_EXCEL" }]}
        />{" "}
      </div>
      <div style={gridStyle}>
        <TableContext.Consumer>
          {(props) => (
            <Table
              style={{ minHeight: "60vh", maxWidth: "80vw" }}
              columns={columns}
              {...props}
            />
          )}
        </TableContext.Consumer>
      </div>
    </div>
  );
};

export default withTable((params) =>
  getSQLReportView(window.location.pathname.split("/").at(-1), params)
)(SQLReportViewPage);

const gridStyle = {
  display: "flex",
  width: "100%",
  gap: "10px",
  justifyContent: "center",
  alignItems: "center",
  marginTop: "20px",
};

const buttonStyle = {
  border: "none",
  width: "50%",
  height: "30px",
  cursor: "pointer",
  color: "#ffff",
  borderRadius: "5px",
  backgroundColor: "#499d96",
  textAlign: "center",
  outline: "none",
};
